const project1 = "/projects/project-1.png";
const project2 = "/projects/project-2.png";
const project5 = "/projects/project-5.png";
// const project6 = "/projects/project-6.png";
const project7 = "/projects/project-7.png";
const project8 = "/projects/project-8.png";
const project10 = "/projects/project-10.png";
const project11 = "/projects/project-11.png";
const project12 = "/projects/project-12.png";
const project13 = "/projects/project-13.png";
const project14 = "/projects/project-14.png";

// export const ABOUT_CONTENT = `Frontend Developer at TinyTap (Animoca Brands), building AI-powered learning tools and real-time tutoring experiences using React, Next.js, Tailwind CSS, TypeScript, and OpenAI’s Realtime API.
// I design and implement interactive activities such as flashcards, open questions, text highlighting, and camera-based image tasks that help bring AI tutoring to life.

// My background began in automation engineering, developing end-to-end test infrastructures and CI pipelines in the IDF’s Matzpen unit and later at TinyTap, before moving into frontend development focused on AI systems, prompt design, and Gemini-based visual reasoning.
// This combination of testing discipline and creative frontend work shaped how I approach problems: with precision, curiosity, and empathy for the user.

// Outside of work, I’m passionate about surfing, photography, and cooking, things that keep me grounded, creative, and always learning. 🌊📸🔥`;
export const ABOUT_CONTENT = `AI Software Engineer, most recently at TinyTap (Animoca Brands), where I built real-time multimodal learning experiences.
I developed the frontend logic and interfaces that bring AI tutoring to life using React, Next.js, and OpenAI’s Realtime API.

My work involved implementing the tool-calling schemas that allow AI agents to trigger interactive activities like flashcards and word banks based on the conversation.
I also integrated models like Gemini and GPT-4o to handle visual reasoning, enabling the AI to "see" and evaluate user answers in real-time.

I started my career in automation engineering in the IDF’s Matzpen unit, building test infrastructures and CI pipelines. This background taught me the importance of precision and reliable systems, which I now apply to the world of Generative AI and prompt design. I’m passionate about making complex AI technology accessible, intuitive, and engaging for every user.

Outside of work, I’m a surfer, photographer, and cook - hobbies that keep me grounded and always looking for a new perspective. 🌊📸🔥`;

export const EDUCATION = [
    {
        year: "2026 - Present",
        institution: "Nebius Academy",
        degree: "AI Performance Engineering (Supervised Track)",
        description: `Currently enrolled in the supervised track of a 14-week program at Tel Aviv University covering LLM internals, training, RAG systems, MLOps, inference scaling, and production deployment, with hands-on projects, mentorship, and graded assignments.`
    },
    {
        year: "2020 - 2024",
        institution: "The Academic College of Tel-Aviv, Yafo",
        degree: "B.Sc. in Computer Science",
        description: "Graduated with a solid foundation in software development, algorithms, data structures, and a strong focus on practical applications."
    },
    {
        year: "2021",
        institution: "Result Academy",
        degree: "Neuro-Linguistic Programming (NLP) Practitioner",
        description: `Communication and coaching certification focused on understanding behavioral patterns, skills I use daily to communicate clearly and empathize with users and teammates.`
    },
    {
        year: "2016",
        institution: "IDF - BASMACH",
        degree: "Quality Assurance Course",
        description: "Completed a comprehensive course in Quality Assurance, laying the groundwork for my later work in both manual and automated testing."
    },
];

export const EXPERIENCE_CONTENT = [
//     {
//         year: "Sep 2024 - Present",
//         role: "Frontend Developer",
//         company: "TinyTap",
//         description: `Developing AI-powered learning tools and real-time tutoring experiences using React, Next.js, Tailwind, and TypeScript.
// Building interactive activities, including flashcards, open questions, text highlighting, and camera-based image tasks, for an AI tutor built on OpenAI’s Realtime API.
// Integrating Gemini for image understanding and answer evaluation, processing both visual and text inputs to provide accurate, context-aware feedback.
// Creating and refining AI prompt templates for both tools and Gemini interactions to improve feedback accuracy and reliability.
// Taking part in cross-functional collaboration with product and design teams to enhance engagement and learning quality.`,
//         technologies: ["React", "Next.js", "Tailwind", "TypeScript", "OpenAI Realtime API", "Gemini"],
//     },
    {
        year: "2024 - 2026",
        role: "AI Software Engineer",
        company: "TinyTap",
        description: `Developing complex, responsive UI components and interactive educational games using React and TypeScript.
    Implementing the frontend logic for a real-time AI tutor, connecting OpenAI’s Realtime API with dynamic UI elements like flashcards and word banks.
    Building visual feedback systems that react to LLM evaluations (Gemini/GPT-4o), bridging model outputs with interactive interface states.
    Designing and maintaining structured prompt templates to ensure the AI's behavior aligns with the product's UI and educational goals.`,
        technologies: ["React", "Next.js", "TypeScript", "Tailwind", "OpenAI Realtime API", "Gemini"],
    },
    {
        year: "2024",
        role: "Automation Engineer",
        company: "TinyTap",
        description: `Developed and maintained end-to-end and regression test suites for a React-based platform using Python, Selenium, and Pytest.
Integrated test execution into Jenkins CI pipelines to ensure stability and faster deployment cycles.`,
        technologies: ["Python", "Selenium", "Pytest", "Jenkins"],
    },
    {
        year: "2017 - 2019",
        role: "Automation Engineer",
        company: "IDF",
        description: `Designed and built end-to-end automation frameworks and test suites in Java, expanding test coverage across the unit's systems.

Translated specification documents into precise test scenarios, working day-to-day with developers and system analysts in an Agile process.

Mentored junior team members on automation best practices and testing tools.`,
        technologies: ["Java", "Selenium", "LeanFT"],
    },
    {
        year: "2018",
        role: "Quality Assurance Instructor",
        company: "IDF - BASMACH",
        description: `Taught a full software testing course, manual and automated, to a class of 30 students from the Orthodox community, preparing them for QA roles across IDF units.

Built a classroom culture of creativity and critical thinking while keeping the course on track under a demanding army schedule.`,
        technologies: ["Java", "Selenium", "SQL"],
    },
    {
        year: "2017",
        role: "Manual Quality Assurance",
        company: "IDF - MATZPAN",
        description: `Led the creation and execution of test cases across the unit's systems, catching issues before they reached production.

Worked closely with developers and system analysts to keep test plans aligned with how the system was actually specified to behave.`,
        technologies: ["TFS", "MTM", "MongoDB"],
    },
];

// Curated set, AI work first - weaker learning projects (Pomodoro, Email
// Input, Mine Sweeper) were cut deliberately; see git history to restore.
export const PROJECTS = [
    {
        title: "TradeMind - AI-Powered Paper Trading Platform",
        link: "https://ai-trade-mind.vercel.app/",
        image: project14,
        description: "An AI-powered paper trading platform where users trade like legendary investors without risking real money. Chat with AI personalities (Warren Buffett, Cathie Wood, Ray Dalio, or a custom persona) for real-time trade guidance, or let a fully autonomous multi-agent pipeline (Scout, Analyst, Trader) research tickers, manage thesis-based positions, and execute trades on a live Alpaca paper account every 30 minutes. Includes a Pipeline Inspector for full visibility into every agent decision, event-driven risk sensors (price/VIX spikes), vector-based memory (pgvector RAG) so the agent recalls past reasoning, and an analytics dashboard with equity curve and trade journal P&L.",
        technologies: ["Next.js", "TypeScript", "Groq (Llama)", "Supabase", "Clerk", "Alpaca API", "pgvector", "Tailwind CSS"],
    },
    {
        title: "JobTrack - AI-Powered Job Application Tracker",
        link: null,
        image: project13,
        description: "A full-stack job search command center that replaces spreadsheets with a real pipeline tool. Tracks applications end-to-end (drafted → applied → interview → offer), with AI-tailored resumes and cover notes generated per-posting via OpenAI, structured interview-round tracking with a “what went well / what to improve” retro system that aggregates every reflection across all interviews into a single learnings dashboard, and networking outreach tracking. Multi-user with Clerk auth and per-user Supabase row-level isolation.",
        technologies: ["Next.js", "TypeScript", "Supabase", "Clerk", "OpenAI API", "Tailwind CSS"],
    },
    {
        title: "Ally - Voice AI Builder",
        link: "https://meet-ally.vercel.app",
        image: project12,
        description: "A platform that turns a plain-English description into a working voice sales agent. A LangGraph state machine drives the build conversation with Claude through structured outputs (instructor, no raw JSON parsing), while the finished agent places real outbound calls via Vapi, qualifies leads against generated disqualification criteria, and books meetings directly on Cal.com.",
        technologies: ["Claude", "LangGraph", "Vapi", "Cal.com API", "FastAPI"],
    },
    {
        title: "AI Pharmacist Agent",
        link: "https://github.com/ozhayun/Pharma-Agent",
        image: project10,
        description: "A stateless conversational AI system designed to provide safe and accurate medication information. It features deterministic multi-step flows with strict safety guardrails, ensuring the model operates within predefined medical boundaries.",
        technologies: ["OpenAI API", "Node.js", "Docker", "Streaming"],
    },
    {
        title: "Dynamic Form Generator",
        link: "https://generate-dynamic-form.netlify.app/",
        image: project11,
        description: "An engine that renders complex, multi-step forms based on dynamic JSON schemas. It handles real-time validation, conditional logic, and state management, providing a scalable way to build data-driven interfaces without manual UI coding.",
        technologies: ["React", "TypeScript", "Tailwind CSS", "Zustand", "Groq"],
    },
    {
        title: "SumItUp - YouTube Summarizer",
        link: "https://sumitupp.netlify.app/",
        image: project8,
        description: "Turn long videos into concise insights in seconds. Just paste a URL, choose your detail level, and let AI do the rest to summarize the video's content quickly and effectively.",
        technologies: ["React", "JavaScript", "AI"],
    },
    {
        title: "MyDreams",
        link: "https://makeyourdreamscometrue.netlify.app/",
        image: project7,
        description: "An AI-powered application designed to help you organize your aspirations and create an actionable plan to achieve them. Tell the app everything you dream about and watch as it builds a roadmap for success.",
        technologies: ["React", "JavaScript", "CSS", "AI"],
    },
    {
        title: "My Expense",
        link: "https://myxpense.netlify.app/#",
        image: project5,
        description: "myXpense is a modern PWA built with Next.js, TypeScript, and Tailwind that helps users easily track and visualize their daily expenses. It offers a clean UI, quick input flows, and smart categorization to make budgeting simple and accessible. The app works offline and syncs data through Supabase for a seamless, mobile-first experience.",
        technologies: ["React", "JavaScript", "Supabase"],
    },
    // {
    //     title: "Ronen Memorial Website",
    //     link: "https://roneni.netlify.app/he",
    //     image: project6,
    //     description: "Ronen's website is an exciting memorial website that brings together all the memorial projects created over the years in memory of Ronen, my oldest brother, whom I never got to know. The website presents his life story, the annual race in memory of graduates of Hadarim High School, Hod Hasharon, who fell during military service, recipes he loved, songs, ceremonies, and more. It is a space that allows future generations to get to know Ronen and continue the legacy he left behind.",
    //     technologies: ["React", "R2 Cloudflare", "Upstash", "Netlify"],
    // },
    {
        title: "Adventures in the Hospital",
        link: "https://asafharofewebapp1.web.app/",
        image: project1,
        description:
            `"Adventures in the Hospital" is specifically tailored to the process a child undergoes in the pediatric emergency department.
            The text found in pop-up messages throughout the game is written in a way that makes the processes in the emergency room accessible to the child in their own language. This helps to reduce anxiety and stress.`,
        technologies: ["JavaScript", "React", "CSS", "Firebase"],
    },
    {
        title: "CodeBlocks",
        link: "https://codeblocksharing.netlify.app/",
        image: project2,
        description:
            "A platform designed to facilitate code sharing between students and teachers, enhancing the educational experience by allowing real-time collaboration and feedback.",
        technologies: ["Node.js", "JavaScript", "React", "CSS", "MongoDB"],
    },
];